module.exports = ".interface-70 {\n  width: 50% !important; }\n\n.interface-30 {\n  width: 20% !important;\n  margin-left: 15px; }\n"